export const TOP_SEARCHED_GAMES = `
query TopSearchedGames($menuItem: String, $site: String!, $countryCode: String) {
  casinoGameInventory {
    topSearchedGames(site: $site, menuItem: $menuItem, countryCode: $countryCode) {
        handle
        href
        id
        name
        thumbUrlTab
        volatility
        width
        thumbUrl
        thumbUrlMob
        provider { id name handle }
        category { id name }
	menuItem(section: 1) { handle name }
        isNew
        isFeatured
    }
  }
}
`;
